import { render, staticRenderFns } from "./beforeUserReg.vue?vue&type=template&id=80ac62b0"
import script from "./beforeUserReg.vue?vue&type=script&lang=js"
export * from "./beforeUserReg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports